import { ISpecialtySchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

export const getNewBusinessSaleSpecialtiesTitle = (specialties?: ISpecialtySchema[] | null): string => {
  if (!specialties) {
    return '';
  }

  const [firstSpecialty, ...otherSpecialties] = specialties;

  const { rusName: firstSpecialtyTitle } = firstSpecialty;
  const otherSpecialtiesInLowerCase = otherSpecialties.map(item => item.rusName?.toLowerCase());

  return [firstSpecialtyTitle, ...otherSpecialtiesInLowerCase].filter(Boolean).join(', ');
};
